<template>
  <div class="page-container">
    <!-- 协议切换 Tab -->
    <el-card>
      <el-tabs v-model="activeType" @tab-click="handleTabChange">
        <el-tab-pane label="用户协议" name="user_agreement" />
        <el-tab-pane label="隐私政策" name="privacy_policy" />
        <el-tab-pane label="合伙人用户协议" name="partner_user_agreement" />
        <el-tab-pane label="合伙人隐私协议" name="partner_privacy_policy" />
      </el-tabs>

      <div v-loading="loading" class="agreement-content">
        <template v-if="current">
          <!-- 协议信息栏 -->
          <div class="agreement-meta">
            <el-descriptions :column="3" border size="small">
              <el-descriptions-item label="协议标题">{{ current.title }}</el-descriptions-item>
              <el-descriptions-item label="版本号">v{{ current.version }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <el-tag :type="current.status === 1 ? 'success' : 'danger'" size="small">
                  {{ current.status === 1 ? '启用' : '禁用' }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="最后更新">{{ current.updated_at }}</el-descriptions-item>
            </el-descriptions>
          </div>

          <!-- 内容预览 -->
          <div class="agreement-preview" v-if="!editing">
            <div class="preview-header">
              <span class="preview-label">协议内容预览</span>
              <el-button
                v-permission="['content:agreement:update']"
                type="primary" size="mini" icon="el-icon-edit"
                @click="startEdit"
              >编辑</el-button>
            </div>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="preview-body" v-html="current.content || '<p style=\'color:#c0c4cc\'>暂无内容</p>'" />
          </div>

          <!-- 编辑表单 -->
          <div class="agreement-edit" v-else>
            <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="80px">
              <el-form-item label="标题" prop="title">
                <el-input v-model="editForm.title" placeholder="请输入协议标题" style="width: 400px" />
              </el-form-item>
              <el-form-item label="版本号" prop="version">
                <el-input v-model="editForm.version" placeholder="如 1.0 / 2.0.1" style="width: 200px" />
              </el-form-item>
              <el-form-item label="状态">
                <el-radio-group v-model="editForm.status">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <rich-editor v-model="editForm.content" :height="440" placeholder="请输入协议内容..." />
              </el-form-item>
              <el-form-item>
                <el-button size="mini" @click="cancelEdit">取消</el-button>
                <el-button type="primary" size="mini" :loading="saving" @click="handleSave">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getAgreementList, updateAgreement } from '@/api/agreement'

export default {
  name: 'AgreementManage',
  data() {
    return {
      activeType: 'user_agreement',
      loading: false,
      saving: false,
      editing: false,
      agreements: {},
      current: null,
      editForm: { title: '', content: '', version: '', status: 1 },
      editRules: {
        title:   [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        version: [{ required: true, message: '版本号不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const res = await getAgreementList()
        const map = {}
        ;(res.data || []).forEach(item => { map[item.type] = item })
        this.agreements = map
        this.current = map[this.activeType] || null
      } finally {
        this.loading = false
      }
    },

    handleTabChange() {
      this.editing = false
      this.current = this.agreements[this.activeType] || null
    },

    startEdit() {
      if (!this.current) return
      this.editForm = {
        title:   this.current.title,
        content: this.current.content || '',
        version: this.current.version,
        status:  this.current.status
      }
      this.editing = true
    },

    cancelEdit() {
      this.editing = false
      this.$refs.editForm && this.$refs.editForm.resetFields()
    },

    handleSave() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          const res = await updateAgreement({
            type:    this.activeType,
            title:   this.editForm.title,
            content: this.editForm.content,
            version: this.editForm.version,
            status:  this.editForm.status
          })
          this.$message.success('保存成功')
          this.agreements[this.activeType] = res.data
          this.current = res.data
          this.editing = false
        } finally {
          this.saving = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.agreement-content {
  min-height: 300px;
}

.agreement-meta {
  margin-bottom: 20px;
}

.agreement-preview {
  .preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .preview-label {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
    }
  }
  .preview-body {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 20px 24px;
    min-height: 200px;
    background: #fafafa;
    line-height: 1.8;
    color: #303133;
    font-size: 14px;
    overflow: auto;

    ::v-deep h1, ::v-deep h2, ::v-deep h3 {
      margin: 12px 0 8px;
      font-weight: 600;
    }
    ::v-deep p { margin: 0 0 10px; }
    ::v-deep ul, ::v-deep ol { padding-left: 20px; margin-bottom: 10px; }
  }
}

.agreement-edit {
  .editor-toolbar {
    margin-bottom: 6px;
    .editor-hint { font-size: 12px; color: #909399; }
  }
  .content-textarea {
    ::v-deep textarea {
      font-family: 'Courier New', Courier, monospace;
      font-size: 13px;
      line-height: 1.6;
    }
  }
}
</style>
